const dropsMock = [
    {},{},{}
]

export default dropsMock;